export default "__VITE_ASSET__fd5408e4__"